import { DataSource } from "../../../../../Pages/Data/Visualize/DataReview/Types/DataSource"
import { MedicationJSON, RenderStrategy } from "../../../../../Pages/Data/Visualize/DataReview/Types/Trace"

export type MedicationInfo = {
    id: number
    code: string
    name: string
}

export type HarmonizedMedication = {
    id: number
    name: string
    color: string
    class: string
}

export type EMRData = HarmonizedMedication & {
    dataStreams: EMRDataStream[]
}

export type EMRDataStream = {
    code: string
    data: number[]
    isContinuous: boolean
    times: number[]
    units: string
}

export type EMRDataStreamId = {
    id: number
    code: string
    units: string
}

export const toMedicationJSON = (medication: HarmonizedMedication) => {
    const dataKey = medication.id.toString()

    const medicationJSON: MedicationJSON = {
        id: medication.id.toString(),
        class: medication.class,
        dataKey: dataKey, // The unique string that tells us where to get the data to draw on the screen
        rawDataKey: medication.name, // The string that tells us what we originally configured
        dataSource: DataSource.CURRENT_PATIENT,
        renderStrategy: RenderStrategy.INFUSION_MEDICATION, // Here as a default, but could change.
        units: "", // will be available later if the medication has been administered.
        isCompositePart: false,
        color: medication.color,
        name: medication.name,
        isEMRData: true,
        isVisible: true
    }

    return medicationJSON
}
